var render = function render(){var _vm=this,_c=_vm._self._c;return _c('panel',{attrs:{"heading":_vm.label}},[(!_vm.activated)?[_c('div',{staticClass:"heading"},[_vm._v("\n      Activate your account with a valid Iowa driver's license or an activation code.\n    ")]),_vm._v(" "),_c('license-code')]:_c('span',[_vm._v("Welcome to "+_vm._s(_vm.$store.getters['app/appName'])+"!")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }